export default __webpack_public_path__ + "static/media/staffs.a44ec866.jpg";